import { BinWithChildren } from '../../utils/createBinTree'

export const relevantSubtreeRecursiveSearch = (subtree: BinWithChildren[], binIDs: string[]): BinWithChildren[] => {
  const bins: BinWithChildren[] = []
  for (const tree of subtree) {
    const foundChildrenIDs = relevantSubtreeRecursiveSearch(tree.children ?? [], binIDs)
    if (foundChildrenIDs.length > 0) {
      bins.push({ ...tree, children: foundChildrenIDs })
    } else if (binIDs.includes(tree.id)) {
      bins.push({ ...tree, children: [] })
    }
  }
  return bins
}
